export default __webpack_public_path__ + "static/media/a020-it-3.cd7a2268.svg";